import ProgressionImg from "../../images/who-we-are/progresion.png";
import WorkoutImg from "../../images/who-we-are/workout.png";
import NutritionImg from "../../images/who-we-are/nutritions.png";

export const cardList = [
  {
    img: ProgressionImg,
    title: "Progress Tracking",
    description:
      "Our certified coach tracks your progress and adjusts your program regularly to ensure you keep achieving your fitness milestones.",
  },
  {
    img: WorkoutImg,
    title: "Intense Workouts",
    description:
      "From weight training and cardio to functional fitness, we offer a wide variety of workouts designed to challenge you at every level.",
  },
  {
    img: NutritionImg,
    title: "Lifestyle Coaching",
    description:
      "Our fitness & lifestyle coach guides you on nutrition, recovery and healthy habits so you can achieve long-lasting transformation.",
  },
];
